// eMaint work-order deep links. One definition, so a change to the tenant or
// the hash route does not have to be found in every page that links out.

const EMAINT_WORK_ORDER_BASE =
  'https://x43.emaint.com/wc.dll?X3~emproc~x3Hubv2#/WORK/';

/**
 * @param {?string|number} workOrderNumber
 * @returns {?string} null when there is no number to link to.
 */
export default function emaintWorkOrderUrl(workOrderNumber) {
  if (workOrderNumber === null || workOrderNumber === undefined) return null;
  const wo = String(workOrderNumber).trim();
  return wo ? `${EMAINT_WORK_ORDER_BASE}${encodeURIComponent(wo)}` : null;
}
